module.exports = __webpack_public_path__ + "img/sjyth.d2ac99e5.png";